import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, homeFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Zap } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(homeFor(u.role), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E4F3F2] via-[#F2F8FA] to-[#E6EFFB] flex items-center justify-center p-6"
      data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-sm card-tactical p-8 space-y-6 shadow-lg" data-testid="login-form">
        <div className="flex flex-col items-center text-center gap-3">
          <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-teal-500 to-sky-500 flex items-center justify-center shadow-md">
            <Zap className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-extrabold tracking-tight m-0">YuGO <span className="text-teal-600">Rides</span></h1>
            <p className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold mt-1">Ops Command</p>
          </div>
        </div>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
            <Input data-testid="login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="you@yugorides.com"
              className="bg-slate-50 border-slate-200 h-11" />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
            <Input data-testid="login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="bg-slate-50 border-slate-200 h-11" />
          </div>
        </div>
        {error && (
          <div data-testid="login-error" className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600">
            {error}
          </div>
        )}
        <Button data-testid="login-submit" type="submit" disabled={loading}
          className="w-full h-11 bg-teal-600 hover:bg-teal-700 text-white font-semibold rounded-full">
          {loading ? "Signing in…" : "Sign In"}
        </Button>
      </form>
    </div>
  );
}
